// extracted by mini-css-extract-plugin
export default {"container":"DevelopVersionInfo_container__L+SaB","table":"DevelopVersionInfo_table__aQrJZ"};